
import "./MenuItem.css";
import { NavLink } from "react-router-dom";

export default function MenuItem({ to, icon, children, onClick }) {
  return (
    <li className="nav-item m-0">
      <NavLink
        to={to}
        className={({ isActive }) =>
          "nav-link d-flex  align-items-center gap-1 px-0 ps-1 px-lg-3 py-2" +
          (isActive ? " active bg-white text-dark rounded" : " text-light")
        }
        onClick={onClick}
      >
        {icon}
        {children}
      </NavLink>
    </li>
  );
}
